module.exports = __webpack_public_path__ + "img/West-VIP-Lounge-BG.e6ae62ea.jpg";